import React from 'react';
import ListItem from './AdminListItem';
import { Table } from 'reactstrap';
import NoItems, { ContentType } from 'components/NoItems';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ColumnHeader = styled.th`
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  color: #767676 !important;
  border: none !important;
  padding: 2rem 0 0.5rem !important;
  min-width: 220px;

  @media only screen and (max-width: 768px) {
    min-width: auto;
  }
`;

const StyledButtonHeader = styled(ColumnHeader)`
  padding: 0 !important;
  text-align: right;
`;
const EmailColumnHeader = styled(ColumnHeader)`
  width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledTable = styled(Table)`
  table-layout: fixed;

  tbody tr {
    td {
      transition: background 0.2s;
    }
    td div[id*='user_avatar'] {
      transition: transform 0.2s;
    }

    &:hover {
      td {
        background: #f5fbff;

        &:first-child {
          div[id*='user_avatar'] {
            transform: translateX(5px);
          }
        }

        &:last-child {
          button.btn {
            border: 1px solid #767676;
            transform: translateX(-5px);
          }
        }
      }
    }
  }
`;

const AdminList = ({
  inviteCrewButton,
  users,
  currentUserId,
  onDeleteClick,
  onResendInviteClick,
  isLoading,
}) => {
  const rows = users.map((user) => (
    <ListItem
      key={`admin-list-table-row-${user._id}`}
      {...{
        onResendInviteClick,
        onDeleteClick,
        user,
        currentUserId,
      }}
    />
  ));

  return (
    <StyledTable>
      <thead>
        <tr>
          <ColumnHeader>Name</ColumnHeader>
          <EmailColumnHeader className="d-none d-lg-table-cell">
            Email
          </EmailColumnHeader>
          <StyledButtonHeader>{inviteCrewButton}</StyledButtonHeader>
        </tr>
      </thead>
      <tbody>
        {isLoading ? (
          <NoItems type={ContentType.User} isLoading={isLoading} />
        ) : (
          rows
        )}
      </tbody>
    </StyledTable>
  );
};

AdminList.propTypes = {
  inviteCrewButton: PropTypes.element.isRequired,
  users: PropTypes.array.isRequired,
  onResendInviteClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
};

export default AdminList;
